import ua from "ua";
import { query, stringify, append } from "qs";
import user from "user";
import bridge from "bridge";
import lightLogin from "lightLogin";
import convertSchemaToUrl from "convertSchemaToUrl";
import wxapi from "wxapi";
import alipayAPI from "alipayAPI";
import tiktokApi from "tiktokApi";
import { shared as progress } from "progress";
import ChannelManager from "ChannelManager";
import locationConfig from "location";
import { OrderType } from "enums";
import CryptoJS from "crypto-js";

let loadZHSDK;
if (ua.isFromZhaohang()) {
  loadZHSDK = require("zhaohangSdk").loadZHSDK;
}
const ALIPAY_APPID = "\x32\x30\x31\x37\x30\x39\x30\x36\x30\x38\x35\x38\x36\x36\x35\x39";
const WXMP_APPID = "wx5ceacaa292159bc8";
const ALI_APPID = "2017090608586659";

/**
 * alipay地址适配跳转
 * @param page
 * @param params
 */
function navigateToAliMiniProgram(page = "", params = {}, twice = false) {
  page = page[0] === "/" ? page : "/" + page;
  let query = encodeURIComponent(stringify(params));
  let url = `alipays://platformapi/startapp?appId=${ALIPAY_APPID}&page=${page}&query=${query}`;
  console.log("aliMiniProgram", url.replace(ALIPAY_APPID, process.env.NODE_ENV === "dev" ? ALIPAY_APPID : "**********"));
  location.href = url;
}

/**
 * 跳转到微信小程序
 * @param {*} path 页面路径
 * @param {*} params 页面参数
 */
function navigateToWXMiniProgram(path = "", params = {}, callback) {
  const query = encodeURIComponent(stringify(params));
  const url = `weixin://dl/business/?appid=${WXMP_APPID}&path=${path}&query=${query}&env_version=release`;
  location.href = url;
  callback && callback();
}
function navigateToAliPayProgram(path = "", params = {}, callback) {
  const query = encodeURIComponent(stringify(params));
  const url = `alipays://platformapi/startapp?appId=${ALI_APPID}&page=${path}&query=${query}`;
  location.href = url;
  callback && callback();
}

module.exports = {
  // 微信小程序支付
  toWXMPPay(params = {}, callback) {
    navigateToWXMiniProgram("pages/pay/transfer-pay", params, callback);
  },
  toALIPAYMPay(params = {}, callback) {
    navigateToAliPayProgram("pages/pay/transfer-pay", params, callback);
  },
  toWXMerchantPay(params = {}) {
    navigateToWXMiniProgram("pages/pay/merchant-transfer-pay", params);
  },
  toWXSheQun(params = {}) {
    navigateToWXMiniProgram("pages/activity/communityList", params);
  },
  toHome() {
    let currentChannel = ChannelManager.current();
    if (currentChannel && currentChannel.isListHome) {
      // location.href = '/activity/new-category-home.html'
      this.pushWeb("/activity/new-category-home.html");
    } else if (ua.isPiaoniu()) {
      bridge.gotoNativeScheme("piaoniu://home");
    } else if (ua.isPiaoniuMiniProgram()) {
      wxapi.load().then(() => {
        wx.miniProgram.switchTab({
          url: "/pages/tabBar/home/index",
        });
      });
    } else if (ua.isAliPay()) {
      if (ua.isPiaoniuAliMiniProgram()) {
        alipayAPI.load().then(() => {
          my.switchTab({
            url: `/pages/tabBar/home/index`,
          });
        });
      } else {
        navigateToAliMiniProgram("/pages/tabBar/home/index");
      }
    } else if (ua.isPiaoniuTiktokMiniProgram()) {
      tiktokApi.load().then(() => {
        tt.miniProgram.switchTab({
          url: `/pages/tabBar/home/index`,
        });
      });
    } else if (ua.isMobile()) {
      // location.href = '/'
      this.pushWeb("/");
    } else {
      this.pushWeb("http://www.piaoniu.com");
      // location.href = 'http://www.piaoniu.com'
    }
  },
  toChooseTicketByProduct(product) {
    if (ua.isPiaoniu()) {
      const iOSHref = `piaoniu://choose_ticket?activityId=${product.activityId}`;
      bridge.gotoNativeScheme(iOSHref);
    } else if (ua.isPiaoniuMiniProgram()) {
      let url = `/pages/activity/b2c-ticketChoose?activityId=${product.activityId}`;
      wxapi.load().then(() => {
        wx.miniProgram.navigateTo({
          url: url,
        });
      });
    } else if (ua.isAliPay()) {
      if (ua.isAliMiniProgram()) {
        alipayAPI.load().then(() => {
          my.navigateTo({
            url: `/pages/choose-ticket/index?activity=${product.activityId}`,
          });
        });
      } else {
        navigateToAliMiniProgram("/pages/choose-ticket/index", {
          activityId: product.activityId,
        });
      }
    } else if (ua.isMobile() || ua.isWanda()) {
      let url = `/activity/choose_ticket.html?id=${product.activityId}`;

      if (product.eventId) {
        url += `&eventId=${product.eventId}`;
      }

      if (product.ticketCategoryId) {
        url += `&ticketCategoryId=${product.ticketCategoryId}`;
      }

      url += "&selfSupport=true";
      location.href = url;
    } else if (ua.isPiaoniuTiktokMiniProgram()) {
      tiktokApi.load().then(() => {
        tt.miniProgram.navigateTo({
          url: `/pages/choose-ticket/index?activity=${product.activityId}`,
        });
      });
    } else {
      let url = `http://www.piaoniu.com/activity/${product.activityId}`;

      if (product.eventId || product.ticketCategoryId) {
        url +=
          "?" +
          stringify({
            eventId: product.eventId,
            ticketCategoryId: product.ticketCategoryId,
          });
      }

      url += "&selfSupport=true";
      location.href = url;
    }
  },
  toChooseTicket(activity) {
    function appendQueries(origin) {
      return append(origin, query);
    }

    if (ua.isPiaoniu()) {
      var nativeScheme;
      if (ua.versionGreaterThanOrEqualTo("3.3.0")) {
        nativeScheme = `piaoniu://choose_ticket_b2c?activityId=${activity.id}`;
      } else {
        nativeScheme = `piaoniu://choose_ticket?activityId=${activity.id}`;
      }
      nativeScheme = appendQueries(nativeScheme);
      if (activity.locationType) {
        nativeScheme = nativeScheme + "&eventId=" + activity.activityEventId;
      }
      bridge.gotoNativeScheme(nativeScheme);
    } else if (ua.isPiaoniuMiniProgram()) {
      let url = `/pages/activity/b2c-ticketChoose?activityId=${activity.id}`;
      url = appendQueries(url);
      wxapi.load().then(() => {
        wx.miniProgram.navigateTo({
          url: url,
        });
      });
    } else if (ua.isPiaoniuTiktokMiniProgram()) {
      let url = `/pages/choose-ticket/index?activityId=${activity.id}`;
      url = appendQueries(url);
      tiktokApi.load().then(() => {
        tt.miniProgram.navigateTo({
          url: url,
        });
      });
    } else if (ua.isAliPay()) {
      let url = `/pages/choose-ticket/index?activityId=${activity.id}`;
      url = appendQueries(url);
      if (ua.isAliMiniProgram()) {
        alipayAPI.load().then(() => {
          my.navigateTo({
            url: url,
          });
        });
      } else {
        navigateToAliMiniProgram("/pages/choose-ticket/index", {
          activityId: activity.id,
          ...query,
        });
      }
    } else if (ua.isMobile() || ua.isWanda()) {
      let url = `/activity/choose_ticket.html?id=${activity.id}`;
      // if (activity.proxyBuy) {
      // 	url = `/activity/grab_votes.html?id=${activity.id}`
      // } else {
      // 	url = `/activity/choose_ticket.html?id=${activity.id}`
      // }
      if (query.shopId) {
        url += "&shopId=" + query.shopId;
      }
      if (query.sharer) {
        url += "&sharer=" + query.sharer;
      }

      if (activity.b2cOpened) {
        url += "&selfSupport=true";
      }

      if (activity.locationType) {
        url += "&eventId=" + activity.activityEventId;
      }

      location.href = url;
    } else {
      // location.href = `http://www.piaoniu.com/activity/${activity.id}`

      let pcUrl = `https://www.piaoniu.com/activity/${activity.id}`;
      if (query.shopId) {
        location.href = pcUrl + `?shopId=${query.shopId}`;
      } else {
        location.href = pcUrl;
      }
    }
  },
  toChooseTicketPinTuan(pinTuanCampaignId, pinTuanId) {
    let params = {
      pinTuanCampaignId,
      pinTuanId,
    };
    if (ua.isPiaoniu()) {
      if (ua.versionGreaterThanOrEqualTo("5.12")) {
        let appUrl = "piaoniu://choose_ticket_pintuan";

        bridge.gotoNativeScheme(appUrl, params);
      } else {
        progress.showMessage("APP版本太低，升级最新版本就能参与拼团了哦");
      }
      return;
    }

    location.href = `/activity/choose_ticket.html?${stringify(params)}&selfSupport=true`;
  },
  activityURL(id, shopId) {
    if (ua.isPiaoniu()) {
      let AppStr = stringify({
        activityId: id,
        shopId: shopId || query.shopId,
      });
      return `piaoniu://activity_detail?${AppStr}`;
    } else if (ua.isMobile()) {
      // let mobileStr = stringify({
      // 	shopId: shopId || query.shopId
      // })
      // return `/activity/detail.html?id=${id}` + (mobileStr && '?' + mobileStr)
      return locationConfig.formatHref("/activity/detail.html", { id: id, shopId: shopId || query.shopId });
    } else {
      return `http://www.piaoniu.com/activity/${id}`;
    }
  },
  tourDetailURL(id, ipType, href, loggerParams) {
    if (ua.isPiaoniu()) {
      let AppStr = stringify({
        stationId: id,
      });
      return `piaoniu://station_detail?${AppStr}`;
    } else {
      return locationConfig.formatHref("/tour/detail.html", { id, ipType, href, loggerParams });
    }
  },
  toIpList() {
    return this.toDispatchURL("/ipList/index.html");
  },
  toChooseSeat(id, type) {
    var str = `seat_map?activityId=${id}`;
    if (query.shopId) {
      str = str + "&shopId=" + query.shopId;
    }
    if (type) {
      str = str + "&type=" + type;
    }
    var url = convertSchemaToUrl(str);
    if (ua.isPiaoniu()) {
      bridge.gotoNativeScheme(url);
    } else if (ua.isPiaoniuMiniProgram()) {
      let url = `/pages/activity/detail?activityId=${id}`;
      if (query.shopId) {
        url += `&shopId=${query.shopId}`;
      }
      wxapi.load().then(() => {
        wx.miniProgram.navigateTo({
          url: url,
        });
      });
    } else {
      location.href = url;
    }
  },
  toChooseSeatWithParams(params) {
    var str = `seat_map?${stringify(params)}`;
    if (query.shopId) {
      str = str + "&shopId=" + query.shopId;
    }
    var url = convertSchemaToUrl(str);
    if (ua.isPiaoniu()) {
      bridge.gotoNativeScheme(url);
    } else if (ua.isPiaoniuMiniProgram()) {
      let url = `/pages/activity/online-seat/online-seat?activityId=${params.activityId}`;
      if (query.shopId) {
        url += `&shopId=${query.shopId}`;
      }
      wxapi.load().then(() => {
        wx.miniProgram.navigateTo({
          url: url,
        });
      });
    } else {
      location.href = url;
    }
  },
  toSeatTable(id, type) {
    var str = `seat_table?activityId=${id}`;
    if (query.shopId) {
      str = str + "&shopId=" + query.shopId;
    }
    if (type) {
      str = str + "&type=" + type;
    }
    var url = convertSchemaToUrl(str);
    if (ua.isPiaoniu()) {
      bridge.gotoNativeScheme(url);
    } else {
      if (query.shopId) {
        location.href = `/activity/online-seat.html?id=${id}&shopId=${query.shopId}&type=${type}`;
      } else {
        location.href = `/activity/online-seat.html?id=${id}&type=${type}`;
      }
    }
  },
  toSeatTableWithParams(params) {
    var str = `seat_table?${stringify(params)}`;
    if (query.shopId) {
      str = str + "&shopId=" + query.shopId;
    }
    var url = convertSchemaToUrl(str);
    if (ua.isPiaoniu()) {
      bridge.gotoNativeScheme(url);
    } else {
      params.id = params.activityId;
      delete params.activityId;

      str = `/activity/online-seat.html?${stringify(params)}`;
      if (query.shopId) {
        str += "&shopId=" + query.shopId;
      }

      location.href = str;
    }
  },

  commonJump(scheme, toDownload) {
    var url = convertSchemaToUrl(scheme);
    if (ua.isPiaoniu()) {
      bridge.gotoNativeScheme(url);
    } else if (ua.isPiaoniuMiniProgram()) {
      wxapi.load().then(() => {
        if (url.indexOf("tabBar") !== -1) {
          wx.miniProgram.switchTab({
            url: url,
          });
        } else {
          wx.miniProgram.navigateTo({
            url: url,
          });
        }
      });
    } else {
      this.toDispatchURL(url, {
        toDownload,
      });
    }
  },
  toDispatchURL(url, params = {}) {
    if (url.indexOf(".piaoniu.com") === -1) {
      if (ua.isBeta()) {
        url = `//${location.host}` + url;
      } else {
        url = "//m.piaoniu.com" + url;
      }
      // url = (ua.isBeta() ? `//${location.host}` : '//m.piaoniu.com') + url
    }
    let toDownload = +!!params.toDownload;
    // const q = stringify({
    //   uri: url,
    //   toDownload,
    //   channel: params.channel
    // })
    // location.href = 'https://www.piaoniu.com/pnapp/dispatch?' + q
    if (toDownload) {
      window.location.assign("/appDownload.html");
    } else {
      // window.location.assign(url);
      window.location.assign(locationConfig.formatHref(url, {}));
    }
  },
  toPGCVideo() {},
  toVenue(id) {
    this.commonJump(`venue_detail?venueId=${id}`);
  },
  toApplyManualCompensation(orderId, refundArrivalTip, refundReason, refundAmount, compensateAmount, violationTime, compensateRatio) {
    if (ua.isPiaoniu()) {
      if (ua.versionGreaterThanOrEqualTo("9.9.24")) {
        bridge.gotoFlutterScheme("piaoniuflutter://apply_refund_compensation", {
          orderId,
        });
      } else {
        progress.showMessage("请升级最新版本使用该功能");
      }
    } else {
      const SECRET_KEY = process.env.AES_SECRET_KEY;
      const params = { orderId, refundArrivalTip, refundReason, refundAmount, compensateAmount, violationTime, compensateRatio };
      const paramsStr = stringify(params);
      const encryptedData = CryptoJS.AES.encrypt(paramsStr, SECRET_KEY).toString();
      location.href = `/order/apply-manual-compensation.html?query=${encodeURIComponent(encryptedData)}`;
    }
  },
  toRefundRule() {
    location.href = "/about/refund.html";
  },
  toActivity(id, shopId) {
    if (ua.isPiaoniuMiniProgram()) {
      wxapi.load().then(() => {
        wx.miniProgram.navigateTo({
          url: `/pages/activity-detail/index?id=${id}`,
        });
      });
      return;
    }
    if (ua.isPiaoniuAliMiniProgram()) {
      alipayAPI.load().then(() => {
        my.navigateTo({
          url: `/pages/activity-detail/index?id=${id}`,
        });
      });
      return;
    }

    if (ua.isPiaoniuTiktokMiniProgram()) {
      tiktokApi.load().then(() => {
        tt.miniProgram.redirectTo({
          url: `/pages/activity-detail/index?id=${id}`,
        });
      });
      return;
    }

    if (ua.isAliMiniProgram()) {
      alipayAPI.load().then(() => {
        my.postMessage({
          data: {
            action: "toActivityDetail",
            data: {
              id,
            },
          },
        });
      });
      my.navigateToMiniProgram({
        appId: "2017090608586659",
        path: `pages/activity-detail/index?id=${id}`,
        success: (res) => {
          console.log(JSON.stringify(res));
        },
        fail: (res) => {
          console.log(JSON.stringify(res));
        },
      });
    }

    if (ua.isAliPay()) {
      navigateToAliMiniProgram("/pages/activity-detail/index", {
        id,
      });
      return;
    }
    let url = this.activityURL(id, shopId);
    if (ua.isFromZhaohang()) {
      loadZHSDK().then(() => {
        if (window.cmblife) {
          let toUrl = location.protocol + "//" + location.host + url;
          let cmbUrl = `cmblife://go?url=web&version=v2&next=${encodeURIComponent(toUrl)}`;
          window.cmblife.executeProtocol(cmbUrl);
        }
      });
      return;
    }
    if (ua.isPiaoniu()) {
      bridge.gotoNativeScheme(url);
    } else {
      this.toDispatchURL(url);
    }
    // this.commonJump(url)
  },
  toMiniOrderConfirm(params, buyType) {
    if (ua.isPiaoniuMiniProgram()) {
      wxapi.load().then(() => {
        wx.miniProgram.navigateTo({
          url: `/pages/order/confirm/confirm?goods=${params}&type=${buyType}`,
        });
      });
      return;
    }
    if (ua.isPiaoniuAliMiniProgram()) {
      alipayAPI.load().then(() => {
        my.navigateTo({
          url: `/pages/order/confirm/confirm?goods=${params}&type=${buyType}`,
        });
      });
      return;
    }

    if (ua.isPiaoniuTiktokMiniProgram()) {
      tiktokApi.load().then(() => {
        tt.miniProgram.redirectTo({
          url: `/pages/order/confirm/confirm?goods=${params}&type=${buyType}`,
        });
      });
      return;
    }

    if (ua.isAliMiniProgram()) {
      // alipayAPI.load().then(() => {
      // 	my.postMessage({
      // 		data: {
      // 			action: "toActivityDetail",
      // 			data: {
      // 				id
      // 			}
      // 		}
      // 	})
      // })
      my.navigateToMiniProgram({
        appId: "2017090608586659",
        path: `/pages/order/confirm/confirm?goods=${params}&type=${buyType}`,
        success: (res) => {
          console.log(JSON.stringify(res));
        },
        fail: (res) => {
          console.log(JSON.stringify(res));
        },
      });
      return;
    }

    if (ua.isAliPay()) {
      navigateToAliMiniProgram("/pages/order/confirm/confirm", {
        goods: params,
        type: buyType,
      });
      return;
    }
  },
  toWeappCommunity(pageType, actorId, sourcePage) {
    /**
     * 唤起小程序参数信息：
     * path：通过明文 URL Scheme 打开小程序的页面 path ，必须是已经发布的小程序存在的页面，不可携带 query；
     * query：通过明文 URL Scheme 打开小程序的 query ，最大512个字符，只支持数字，大小写英文以及部分特殊字符：!#$&'()*+,/:;=?@-._~%`，需要url_encode；
     * env_version：要打开的小程序版本,正式版为：release，体验版为：trial，开发版为：develop，仅在微信外打开时生效。注意：若不填写，则默认打开正式版小程序
     * query参数信息：
     * pageType： 页面二维码类型， pageType的值为：FanBase, Proxy -> 粉丝群码， 代抢群码
     * actorId：艺人Id
     * sourcePage: 入口页面
     */
    const pagePath = "pages/activity/community";
    const query = `pageType=${pageType}&actorId=${actorId}&sourcePage=${sourcePage}`;
    if (ua.isPiaoniu()) {
      // name 票牛微信小程序唯一标识
      bridge.gotoNativeScheme(`piaoniu://open_wx_miniprogram?name=gh_08761a1dc9c9&path=${encodeURIComponent(pagePath + "?" + query)}`);
      return;
    }
    if (ua.isPiaoniuMiniProgram()) {
      wxapi.load().then(() => {
        wx.miniProgram.navigateTo({
          url: `/${pagePath}?pageType=${pageType}&actorId=${actorId}&sourcePage=${sourcePage}`,
        });
      });
      return;
    }
    navigateToWXMiniProgram(pagePath, { actorId, pageType, sourcePage });
  },
  // 支付收银台页
  toOrderPay(params) {
    if (ua.isPiaoniu()) {
      let appUrl = "piaoniu://order_pay";

      // params.paymentSubjectId = params.subjectId
      // params.paymentSubjectType = params.subjectType
      // delete params.subjectId
      // delete params.subjectType

      bridge.gotoNativeScheme(appUrl, params);
      return;
    }

    location.href = `/order/orderpay.html?${stringify(params)}`;
  },

  toNewOrderPay(params) {
    if (ua.isPiaoniu()) {
      let appUrl = "piaoniu://order_pay";

      bridge.gotoNativeScheme(appUrl, params);
      return;
    }

    if (ua.isPiaoniuMiniProgram()) {
      wxapi
        .load()
        .then(() => {
          wx.miniProgram.navigateTo({
            url: `/pages/pay/confirm?${stringify(params)}`,
          });
          return null;
        })
        .catch((err) => {
          console.log(err);
        });
      return;
    }

    if (ua.isAliMiniProgram()) {
      alipayAPI
        .load()
        .then(() => {
          my.navigateTo({
            url: `/pages/pay/confirm?${stringify(params)}`,
          });
          return null;
        })
        .catch((err) => {
          console.log(err);
        });
      return;
    }

    if (ua.isPiaoniuTiktokMiniProgram()) {
      tiktokApi
        .load()
        .then(() => {
          tt.miniProgram.navigateTo({
            url: `/pages/pay/confirm?${stringify(params)}`,
          });
          return null;
        })
        .catch((err) => {
          console.log(err);
        });
      return;
    }

    // location.href = `/order/new-pay.html?${stringify(params)}`;
    location.href = `${location.origin}/taro/index.html#/pages/pay/confirm?${stringify(params)}`
  },

  // 确认订单页
  toOrderConfirm(params) {
    if (ua.isPiaoniu()) {
      if (OrderType.seekTicket === params.orderType) {
        let url = `${location.origin}/order/orderconfirm.html?${stringify(params)}`;
        bridge.gotoNativeScheme(`piaoniu://web?url=${encodeURIComponent(url)}`);
        return;
      }
      bridge.gotoNativeScheme("piaoniu://order_confirm", params);
      return;
    }

    if (ua.isAliPay()) {
      navigateToAliMiniProgram("pages/order/confirm/confirm", params);
      return;
    }

    const orderconfirmPath = locationConfig.formatHref("/taro/index.html#/pages/order/confirm/confirm", params || {});
    let currentChannel = ChannelManager.current();
    if (currentChannel && currentChannel.login && !currentChannel.isNeedLogin) {
      currentChannel.login(orderconfirmPath).then(() => {
        location.href = orderconfirmPath;
      });
      return;
    }
    const isLogin = user.isLoginSync();
    if (!isLogin) {
      user.login(orderconfirmPath);
    } else {
      location.href = orderconfirmPath;
    }
  },

  // 下面两个是确认订单页
  toOrderPayWithData(data, num) {
    this.toOrderPayWithParams(stringify(data), num);
  },
  toOrderPayWithParams(params, num) {
    if (ua.isMobile()) {
      params += "&num=" + num;
    } else {
      params += "&count=" + num;
    }
    if (ua.isPiaoniu()) {
      if (ua.isAndroid()) {
        if (ua.versionGreaterThanOrEqualTo("2.5.0")) {
          bridge.gotoNativeScheme("piaoniu://order_confirm?" + params);
        } else {
          bridge.gotoNativeScheme("piaoniu://order_pay?" + params);
        }
      } else {
        bridge.gotoNativeScheme("piaoniu://order_confirm?" + params);
      }
    } else {
      // let redir = ua.isMobile()
      //   ? ('/order/orderconfirm.html?' + params)
      //   : ('//' + (ua.isProduct() ? 'www.piaoniu.com' : 'wwwbeta.piaoniu.com') + '/order/confirm?' + params)
      let redir;

      if (ua.isMobile() || ua.isPiaoniuMiniProgram()) {
        let paramsArr = params.split("&");
        let paramsObj = {};
        paramsArr.forEach((item) => {
          let key = item.split("=")[0];
          let val = item.split("=")[1];
          paramsObj[key] = val;
        });

        let ticketGroupDetails = JSON.stringify([
          {
            ticketGroupId: paramsObj.ticketGroupId,
            count: paramsObj.num,
          },
        ]);

        if (paramsObj["ticketGroupDetails"]) {
          if (ua.isPiaoniuMiniProgram()) {
            redir = "/pages/order/confirm?" + "ticketGroupDetails=" + paramsObj.ticketGroupDetails;
          } else {
            redir = "/order/orderconfirm.html?" + params;
          }
        } else {
          // if (ua.isPiaoniuMiniProgram()) {
          //   redir = '/pages/order/confirm?' + 'ticketGroupDetails=' + ticketGroupDetails
          // } else {
          // }
          redir = "/order/orderconfirm.html?" + params + "&ticketGroupDetails=" + ticketGroupDetails;
        }
      } else {
        redir = "//" + (ua.isProduct() ? "www.piaoniu.com" : "wwwbeta.piaoniu.com") + "/order/confirm?" + params;
      }
      // if (ua.isPiaoniuMiniProgram()) {
      //   let pnid = cookie.get('pnid')
      //   let pner = cookie.get('pner')
      //   if (pner && pnid) {
      //     redir = append(redir, {
      //       pnid: pnid,
      //       pner: pner
      //     })
      //     wxapi.load().then(() => {
      //       wx.miniProgram.navigateTo({
      //         url: redir
      //       })
      //     })
      //   } else {
      //     wxapi.load().then(() => {
      //       wx.miniProgram.redirectTo({
      //         url: `/pages/account/login?redir=${encodeURIComponent('/pages/web/web?url=' + encodeURIComponent(query.redir || location.href))}`
      //       })
      //     })
      //   }
      // } else
      if (ua.isMobile()) {
        location.href = redir;
      } else {
        lightLogin.assureLogin(() => {
          location.href = redir;
        });
      }
    }
  },
  toWriteComment(param) {
    if (ua.isPiaoniuMiniProgram()) {
      wxapi.load().then(() => {
        wx.miniProgram.navigateTo({
          url: `/pages/discover/write/index?activityId=${param.activityId}topicName=${param.activityName || ""}`,
        });
      });
    } else {
      this.commonJump(`review_create?activityId=${param.activityId}&activityName=${param.activityName || ""}`);
    }
  },
  toWriteCircle() {
    this.commonJump("tweet_create");
  },
  toWriteTopic(topicName, topicType, toDownload) {
    let TOPICTYPE = {
      video: 2,
      common: 1,
    };
    if (ua.isPiaoniuMiniProgram()) {
      wxapi
        .load()
        .then(() => {
          wx.miniProgram.navigateTo({
            url: `/pages/discover/write/index?topicName=${topicName}`,
          });
          return null;
        })
        .catch(() => {});
    } else if (ua.isPiaoniu()) {
      this.commonJump(`tweet_create?topicName=${topicName}`, toDownload);
    } else {
      let url = `/discover/write-circle.html?topicName=${topicName}`;
      if (topicType && TOPICTYPE.video === topicType) {
        url += "&type=video";
      }
      location.href = url;
    }
  },
  toWriteOrderComment(param) {
    var url = convertSchemaToUrl(`order_comment?orderId=${param.orderId}`);
    if (ua.isPiaoniu()) {
      bridge.gotoNativeScheme(url);
    } else {
      location.href = `${url}?${stringify(param)}`;
    }
  },
  toReviewList(activityId) {
    this.commonJump(`review_list?activityId=${activityId}`);
  },
  toReviewSearchList(keyword) {
    var url = convertSchemaToUrl(`discover_search?keyword=${keyword}`);
    if (ua.isPiaoniu()) {
      bridge.gotoNativeScheme(url);
    } else {
      location.href = url;
    }
  },
  toCommentList(activityId) {
    var url = convertSchemaToUrl(`review_list?activityId=${activityId}`);
    if (ua.isPiaoniu()) {
      bridge.gotoNativeScheme(url);
    } else {
      location.href = url;
    }
  },
  toCommentDetail(reviewId) {
    var url = convertSchemaToUrl(`review_detail?reviewId=${reviewId}`);
    if (ua.isPiaoniu()) {
      bridge.gotoNativeScheme(url);
    } else {
      // location.href = `/review/detail.html?reviewId=${reviewId}`
      location.href = `/discover/feedDetail.html?type=1&subjectId=${reviewId}`;
    }
  },

  toUserPersonal(userId) {
    var url = convertSchemaToUrl(`user_home?userId=${userId}`);
    if (ua.isPiaoniu()) {
      bridge.gotoNativeScheme(url);
    } else if (ua.isPiaoniuMiniProgram()) {
      wxapi.load().then(() => {
        wx.miniProgram.navigateTo({
          url: `/pages/user/personal?userId=${userId}`,
        });
      });
    } else {
      location.href = locationConfig.formatHref(url, {});
    }
  },
  toUserInfoEditor(userId) {
    var url = convertSchemaToUrl(`edit_profile?userId=${userId}`);
    if (ua.isPiaoniu()) {
      bridge.gotoNativeScheme(url);
    } else {
      location.href = "https://m.piaoniu.com/appDownload.html";
    }
  },
  toTopicDetail(topicName) {
    if (ua.isPiaoniuMiniProgram()) {
      wxapi.load().then(() => {
        wx.miniProgram.navigateTo({
          url: `/pages/discover/topic/index?keyword=${topicName}`,
        });
      });
    } else {
      this.commonJump(`topic_detail?topicName=${topicName}`);
    }
  },
  toFeedDetail(type, subjectId, focus = "") {
    if (ua.isPiaoniuMiniProgram()) {
      wxapi.load().then(() => {
        wx.miniProgram.navigateTo({
          url: `/pages/discover/feed-detail/index?type=${type}&subjectId=${subjectId}`,
        });
      });
    } else {
      this.commonJump(`feed_detail?type=${type}&subjectId=${subjectId}&focus=${focus}`);
    }
  },
  toActorHome(id, options = {}) {
    const queryKey = options.ip ? "ipId" : "actorId";
    const url = `/discover/performer.html?${queryKey}=${id}`;
    if (ua.isPiaoniu()) {
      this.toWebViewUrl(url, true);
    } else {
      location.href = url;
    }
  },
  toApplying(id) {
    if (ua.isPiaoniuMiniProgram()) {
      wxapi.load().then(() => {
        wx.miniProgram.navigateTo({
          url: `/pages/campaign/applying/activity?activityId=${id}`,
        });
      });
    } else {
      location.href = `/applying/detail.html?activityId=${id}`;
    }
  },
  toCircleClub() {
    let url = `https://${location.host}/campaign/circle-club/index.html`;
    if (ua.isPiaoniu()) {
      this.commonJump(`piaoniu://web?url=${url}&fullscreen=1&statusBarStyle=1`);
    } else {
      location.href = url;
    }
  },
  toSeekTicketList() {
    let url = convertSchemaToUrl(this.info.url);
    if (ua.isPiaoniu()) {
      bridge.gotoNativeScheme(url);
    } else {
      location.href = url;
    }
  },
  toSeekTicketDetail(id) {
    let url = `${location.origin}/activity/seek-ticket.html?id=${id}&fullscreen=1`;
    if (ua.isPiaoniu()) {
      bridge.gotoNativeScheme(`piaoniu://web?url=${encodeURIComponent(url)}`);
    } else {
      location.href = url;
    }
  },
  toCoupon() {
    let url = `${location.origin}/user/coupon.html`;
    if (ua.isPiaoniu()) {
      this.commonJump("account_coupons");
    } else {
      location.href = url;
    }
  },
  toWebViewUrl(url, needFullScreen, statusBarStyle = 1) {
    if (url.indexOf("http") === -1) {
      url = location.origin + url;
    }

    if (ua.isPiaoniu()) {
      if (url.indexOf("/taro/index.html") !== -1) {
        let [origin, miniProgramUrl] = url.split("taro/index.html#");
        miniProgramUrl = append(miniProgramUrl, { statusBarStyle });
        if (needFullScreen) {
          miniProgramUrl = append(miniProgramUrl, { fullscreen: 1 });
        }
        url = origin + "taro/index.html#" + miniProgramUrl;
      } else {
        url = append(url, { statusBarStyle });
        if (needFullScreen) {
          url = append(url, { fullscreen: 1 });
        }
      }

      /**
       * webUrl后缀正常化
       */
      bridge.gotoNativeScheme(`piaoniu://web?url=${encodeURIComponent(url)}&needFullScreen=${needFullScreen ? 1 : 0}&statusBarStyle=${statusBarStyle}`);
    } else if (url.indexOf("/taro/index.html") !== -1) {
      /**
       * taro 生成的页面在跳转可以自动跳转到微信小程序上
       */
      const [origin, miniProgramUrl] = url.split("taro/index.html#");
      if (ua.isPiaoniuMiniProgram()) {
        wxapi.load().then(() => {
          wx.miniProgram.navigateTo({
            url: miniProgramUrl,
          });
        });
      } else if (ua.isPiaoniuAliMiniProgram()) {
        alipayAPI.load().then(() => {
          my.navigateTo({
            url: miniProgramUrl,
          });
        });
      } else {
        location.href = url;
      }
    } else {
      location.href = url;
    }
  },
  toBawangpiao(id, campaignCityId) {
    this.toWebViewUrl("/taro/index.html#/pages/campaign/overload-ticket/index?id=" + id + "&campaignCityId=" + campaignCityId);
  },
  // 暂时， 跳转到分期乐开通页面，目前只有app
  toFqlCredits() {
    if (ua.isPiaoniu()) {
      bridge.gotoNativeScheme(`piaoniu://account_home?action=openFqlCredits`);
    }
  },
  // refactor web router
  // 分类列表
  pushCategoryList(categoryId) {
    localStorage.setItem("categoryHomeActiveId",  `{"data": ${categoryId}}`);
    window.location.assign(locationConfig.formatHref("/taro/index.html#/pages/tabBar/activity/index"));
  },
  // 筛选列表
  pushActivityCategoryHome(query) {
    window.location.assign(locationConfig.formatHref("/activity/new-category-home.html", query));
  },
  // 小站列表
  pushTourList() {
    window.location.assign(locationConfig.formatHref("/tour/tourList.html", {}));
  },
  // 小站详情
  pushTourDetail(id, ipType = 0, href = "activity", loggerParams = "") {
    // window.location.assign(locationConfig.formatHref('/tour/detail.html', { id }));

    if (ua.isPiaoniuMiniProgram()) {
      wxapi.load().then(() => {
        wx.miniProgram.navigateTo({
          url: `/pages/tour/detail?id=${id}`,
        });
      });
      return;
    }
    if (ua.isPiaoniuAliMiniProgram()) {
      alipayAPI.load().then(() => {
        my.navigateTo({
          url: `/pages/tour/detail?id=${id}`,
        });
      });
      return;
    }

    if (ua.isPiaoniuTiktokMiniProgram()) {
      tiktokApi.load().then(() => {
        tt.miniProgram.redirectTo({
          url: `/pages/tour/detail?id=${id}`,
        });
      });
      return;
    }

    if (ua.isAliPay()) {
      navigateToAliMiniProgram("/pages/tour/detail", {
        id,
      });
      return;
    }

    let url = this.tourDetailURL(id, ipType, href, loggerParams);
    if (ua.isPiaoniu()) {
      bridge.gotoNativeScheme(url);
    } else {
      this.toDispatchURL(url);
    }
  },
  pushActivtyDetail(id) {
    window.location.assign(locationConfig.formatHref("/activity/detail.html", { id }));
  },
  // 选择场次票档
  pushChooseTicket(id, type) {
    window.location.assign(locationConfig.formatHref("/activity/choose_ticket.html", { id, type, selfSupport: true }));
  },
  // 购票保障
  pushServiceRule(target) {
    const path = target ? `/activity/serviceRule.html#${target}` : "/activity/serviceRule.html";
    window.location.assign(locationConfig.formatHref(path, {}));
  },
  // 证件信息
  pushCertificate() {
    window.location.assign(locationConfig.formatHref("/activity/certificate.html", {}));
  },
  // 证件信息
  pushRealnameEdit() {
    window.location.assign(locationConfig.formatHref("/user/realname-edit.html", {}));
  },
  pushRealnameList() {
    window.location.assign(locationConfig.formatHref("/user/realname-list.html", {}));
  },
  // 评论详情
  pushReviewDetail(reviewId) {
    window.location.assign(locationConfig.formatHref("/review/detail.html", { reviewId }));
  },
  // 演出阵容详情
  pushDiscoverPerformer(actorId) {
    window.location.assign(locationConfig.formatHref("/discover/performer.html", { actorId }));
  },
  // 更多精彩内容待你发现
  pushDiscoverSearch() {
    window.location.assign(locationConfig.formatHref("/discover/search.html", {}));
  },
  // 查看地址
  pushVenueDetail(id) {
    window.location.assign(locationConfig.formatHref("/venue/detail.html", { id }));
  },
  // 报名名额
  pushApplyingList(activityId) {
    window.location.assign(locationConfig.formatHref("/applying/list.html", { activityId }));
  },
  // 跳转传path的页面
  pushWeb(path) {
    window.location.assign(locationConfig.formatHref(path, {}));
  },
  // 跳转订单列表页面
  pushOrderList(tabIndex) {
    window.location.assign(locationConfig.formatHref("/user/order.html", { tabIndex }));
  },
  // 跳转订单详情页面
  pushOrderDetail(id) {
    window.location.assign(locationConfig.formatHref("/order/order-detail.html", { id }));
  },
  // 跳转好麦相关页面
  async pushHaoMaiPage(path) {
    let host = ua.isBeta() ? "dianbeta.haomaitong.com" : "dian.haomaitong.com";
    var url = `https://${host}/${path}`;
    let params = {
      storeId: "1348",
      pn: "pnH5",
    };
    let miniProgramPath = `/${path}&storeId=1348&pn=pnH5`;
    const isLogin = user.isLoginSync();
    if (isLogin) {
      let userInfo = await user.get();
      params["phone"] = userInfo.mobileNo;
      miniProgramPath = miniProgramPath + `&phone=${userInfo.mobileNo}`;
    }
    url = append(url, params);
    if (ua.isPiaoniuAliMiniProgram()) {
      alipayAPI.load().then(() => {
        my.navigateTo({
          url: `/pages/haomai/index?path=${encodeURIComponent(miniProgramPath)}`,
        });
      });
      return;
    }
    if (ua.isPiaoniuMiniProgram()) {
      wxapi.load().then(() => {
        wx.miniProgram.navigateTo({
          url: `/pages/haomai/index?path=${encodeURIComponent(miniProgramPath)}`,
        });
      });
      return;
    }
    window.location.assign(url);
  },
  // replace
  replaceActivtyDetail(id) {
    window.location.replace(locationConfig.formatHref("/activity/detail.html", { id }));
  },
  replaceActivtySeat(query) {
    window.location.replace(locationConfig.formatHref("/activity/seat.html", query));
  },
  replaceActivtyOnlineSeat(query) {
    window.location.replace(locationConfig.formatHref("/activity/online-seat.html", query));
  },
  replaceActivtyChooseTicket(query) {
    window.location.replace(locationConfig.formatHref("/activity/choose_ticket.html", query));
  },
  // 拓展演出详情页
  replaceCampaignPromotionMain(id) {
    window.location.replace(locationConfig.formatHref("/campaign/promotion/main.html", { id }));
  },
  toBindPhone() {
    if (ua.isPiaoniuMiniProgram()) {
      wxapi.load().then(() => {
        wx.miniProgram.navigateTo({
          url: `/pages/bind-phone/index?redirect=${encodeURIComponent(location.href)}`,
        });
      });
    }
    if (ua.isPiaoniuAliMiniProgram()) {
      alipayAPI.load().then(() => {
        my.navigateTo({
          url: `/pages/bind-phone/index?redirect=${encodeURIComponent(location.href)}`,
        });
      });
    }
  },
  toHmGoodsDetail(id) {
    try {
      const localStorageUser = localStorage.getItem("user");
      const userStr = JSON.parse(localStorageUser);
      const user = JSON.parse(userStr) || {};
      const { mobileNo } = user;
      const host = ua.isBeta() ? "https://dianbeta.haomaitong.com" : "https://dian.haomaitong.com";
      let path = `${host}/pages/goods/detail?id=${id}&storeId=1348&pn=pnH5`;
      if (mobileNo) {
        path = `${path}&phone=${mobileNo}`;
      }
      window.location.href = path;
    } catch (e) {
      console.log("toGoodDetail~fail", e);
    }
  },
  toMiniCustomerPage() {
    const url = "https://m.piaoniu.com/agent/kefu.html?id=761480&accessId=4e05783f-fd8e-45f6-8c54-8b05eb5e6d65";
    if (ua.isPiaoniuMiniProgram()) {
      wxapi.load().then(() => {
        wx.miniProgram.navigateTo({
          url: `/pages/web/index?url=${encodeURIComponent(url)}`,
        });
      });
      return;
    }
    if (ua.isPiaoniuAliMiniProgram()) {
      alipayAPI.load().then(() => {
        my.navigateTo({
          url: `/pages/web/index?url=${encodeURIComponent(url)}`,
        });
      });
      return;
    }
  },
};



// WEBPACK FOOTER //
// ./src/mods/navigationUtil.js